import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FaseEnum } from '../../core/enums/fase.enum';
import { EtapaEnum } from '../../core/enums/etapa.enum';
import { CicloService } from '../../shared/services/ciclo.service';
import { catchError, finalize, forkJoin, of } from 'rxjs';
import { PaginationComponent } from '../../shared/components/pagination/pagination.component';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../shared/services/loading.service';
import { BrButton } from '@govbr-ds/webcomponents-angular/standalone';
import { Router } from '@angular/router';
import { TableFilterBarComponent } from "../../shared/components/table-filter-bar/table-filter-bar.component";

@Component({
  selector: 'app-editais',
  templateUrl: './editais.component.html',
  styleUrl: './editais.component.scss',
  imports: [CommonModule, PaginationComponent, BrButton, TableFilterBarComponent],
})
export class EditaisComponent implements OnInit {
  private readonly cicloService = inject(CicloService);
  private readonly loadingService = inject(LoadingService);
  private readonly router = inject(Router);
  private readonly cdr = inject(ChangeDetectorRef);

  readonly tabs: {
    id: string;
    label: string;
    active: boolean;
    data?: any;
    filteredData?: any;
    page: number;
    size: number;
  }[] = [
    {
      id: 'em-andamento',
      label: 'Editais Em Andamento',
      active: true,
      data: null,
      page: 0,
      size: 10,
    }
  ];

  ciclosAbertos: any;
  ciclosEncerrados: any;

  ngOnInit(): void {
    this.loadingService.open();
    forkJoin({
      emAndamento: this.cicloService.search(
        this.tabs[0].page,
        this.tabs[0].size,
        {
          faseParametrizacaoId: FaseEnum.ADESAO_PROFISSIONAL,
          etapaParametrizacaoId: EtapaEnum.INSCRICAO,
          vigente: true,
          ativo: true,
          situacaoId: 2,
          loadInscricao: true,
        },
      )
    })
      .pipe(
        catchError(() => of({ emAndamento: null })),
        finalize(() => this.loadingService.close()),
      )
      .subscribe(({ emAndamento }) => {
        this.tabs[0].data = emAndamento;
        this.cdr.detectChanges();
        this.loadingService.close();
      });
  }

  onTabClick(tabId: string): void {
    this.tabs.forEach((tab) => {
      tab.active = tab.id === tabId;
    });
  }

  onChangePage(page: number, tab: any): void {
    tab.page = page - 1; // Ajusta para zero-based index
    if (tab.id === 'abertos') {
      this.carregarCiclosAbertos(tab);
    } else if (tab.id === 'encerrados') {
      this.carregarCiclosEncerrados(tab);
    }
  }

  onItensPorPaginaAlterado(tamanho: number, tab: any): void {
    tab.size = tamanho;
    tab.page = 0;
    if (tab.id === 'abertos') {
      this.carregarCiclosAbertos(tab);
    } else if (tab.id === 'encerrados') {
      this.carregarCiclosEncerrados(tab);
    }
  }

  onCadastroProfissional(cicloId: number): void {
    this.router.navigate(['/cadastro-profissional', cicloId]);
  }

  onBack(): void {
    this.router.navigate(['/']);
  }

  filterData(filteredData: any[], tab: any): void {
    tab.filteredData = {
      content: filteredData,
    };
    this.cdr.detectChanges();
  }

  private carregarCiclosAbertos(tab: any): void {
    this.loadingService.open();
    this.cicloService
      .search(tab.page, tab.size, {
        faseParametrizacaoId: FaseEnum.ADESAO_PROFISSIONAL,
        etapaParametrizacaoId: EtapaEnum.INSCRICAO,
        vigente: true,
        ativo: true,
        situacaoId: 2,
      })
      .pipe(
        catchError(() => of(null)),
        finalize(() => this.loadingService.close()),
      )
      .subscribe((response) => {
        tab.data = response;
        tab.page = response?.page.number || 0;
        tab.size = response?.page.size || 10;
        this.cdr.detectChanges();
      });
  }

  private carregarCiclosEncerrados(tab: any): void {
    this.loadingService.open();
    this.cicloService
      .search(tab.page, tab.size, {
        faseParametrizacaoId: FaseEnum.ADESAO_PROFISSIONAL,
        etapaParametrizacaoId: EtapaEnum.INSCRICAO,
        vigente: false,
        ativo: true,
        situacaoId: 2,
      })
      .pipe(
        catchError(() => of(null)),
        finalize(() => this.loadingService.close()),
      )
      .subscribe((response) => {
        tab.data = response;
        tab.page = response?.page.number || 0;
        tab.size = response?.page.size || 10;
        this.cdr.detectChanges();
      });
  }
}
